<template>
  <div class="homeApp">
    <h1>Welcome Home !</h1>
    <h2>This very cool website is made by Julien Le Ber</h2>
    <div class="imageArticle">
      <img src="../assets/logo.png" width="400">
      <p>Alidi is a team. We are 2 developpers that created a mobile game called "Alibi".</p>
      <button v-on:click="changeMessage()">Change Message Content</button>
      <h1 class="customMessage">{{message}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeComponent",
  data(){
    return{
      message:"This is default text",
      content: ["Hello World","We love Alibi","Bonjour a Tous","Web is really easy","How to center a div ?","This is NOT made with chatgpt"
        ,"101000101011","Loadshedding",":)","this is a paragraph"]
    }
  },
  methods:{
    changeMessage(){this.message = this.get_random(this.content);},
    get_random (list) {return list[Math.floor((Math.random()*list.length))];},
  }
}
</script>

<style scoped>
h1{
  color: darkgoldenrod;
}
p{
  color: white;
}
.customMessage{
  font-size: 100px;
}
.homeApp{
  background-color: black;
}
button{
  color: black;
  background-color: darkgoldenrod;
  padding: 20px 10px 20px 10px;
  font-weight: bold;
  font-size: 30px;
  border-radius: 20px;
}
</style>